export enum visitorsRoutes{
    visitorsTabs='visits-details',
    createVisitorsRequest='Create-Visitors-Request',
    manageVisitors='Manage-Visitors',
    clientListForVisits = 'client-list-for-visits',
    createVisitRequest = 'create-visit-request',
    visitDetails = 'visit-details',
    visitorUserTabs = 'visitor-user-tabs',
    visitorsClients = 'visitors-clients',
    visitorsLocations = 'visitors-locations',
    totalVisitsReport = 'total-visits-report'
}

export const visitorsRoutesList: MenuItem[] = [
    {
      name: 'visitors.CreateVisits',
      link: visitorsRoutes.clientListForVisits,
      icon: null,
      image: null,
      children: null,
    },
    {
      name: 'visitors.manageVisitors',
      link: visitorsRoutes.manageVisitors,
      icon: null,
      image: null,
      children: null,
    }
]  


export const locationsAndClients: MenuItem[] = [
  {
    name: 'visitors.Clients',
    link: visitorsRoutes.visitorsClients,
    icon: null,
    image: null,
    children: null,
  },
  {
    name: 'visitors.locations',
    link: visitorsRoutes.visitorsLocations,
    icon: null,
    image: null,
    children: null,
  }
] 

export interface MenuItem {
    name: string;
    icon: string | null;
    link: string;
    image: string | null;
    children: MenuItem[] | null;
    role?: string[];
  } 